import { type StyleVars, Themes } from '@varlet/ui';

const commonTheme: Readonly<StyleVars> = {
  '--button-border-radius': '14px',
  '--field-decorator-line-border-radius': '16px',
  '--alert-padding': '12px',
  '--snackbar-color': '#ffffff',
  '--snackbar-width': '440px',
  '--snackbar-border-radius': '18px',
  '--snackbar-border-color': 'rgb(255 255 255 / 0.16)',
  '--snackbar-background': 'rgb(18 18 18 / 0.72)',
} as const;

const lightTheme: Readonly<StyleVars> = {
  ...Themes.md3Light,
  ...commonTheme,
  '--color-body': 'var(--fs-chat-light-canvas)',
  '--color-primary': 'var(--fs-chat-light-action)',
  '--color-primary-palet-1': '#5FB49C',
  '--color-primary-palet-2': '#98DFAF',
  '--color-primary-palet-3': '#abed3a',
  '--color-success': 'var(--fs-chat-light-success)',
  '--color-danger': 'var(--fs-chat-light-error)',
  '--color-info': 'var(--fs-chat-light-info)',
  '--button-primary-color': 'var(--fs-chat-light-action)',
  '--button-primary-text-color': 'var(--fs-chat-light-action-text)',
  '--button-success-color': 'var(--fs-chat-light-success)',
  '--button-danger-color': 'var(--fs-chat-light-error)',
  '--snackbar-success-background':
    'color-mix(in srgb, var(--fs-chat-light-success) 52%, transparent)',
  '--snackbar-info-background': 'color-mix(in srgb, var(--fs-chat-light-info) 52%, transparent)',
  '--snackbar-warning-background':
    'color-mix(in srgb, var(--fs-chat-light-warning) 52%, transparent)',
  '--snackbar-error-background': 'color-mix(in srgb, var(--fs-chat-light-error) 58%, transparent)',
} as const;

const darkTheme: Readonly<StyleVars> = {
  ...Themes.md3Dark,
  ...commonTheme,
  '--color-body': 'var(--fs-chat-dark-canvas)',
  '--color-primary': 'var(--fs-chat-dark-action)',
  '--color-primary-palet-1': '#5FB49C',
  '--color-primary-palet-2': '#98DFAF',
  '--color-primary-palet-3': '#abed3a',
  '--color-success': 'var(--fs-chat-dark-success)',
  '--color-danger': 'var(--fs-chat-dark-error)',
  '--color-info': 'var(--fs-chat-dark-info)',
  '--button-primary-color': 'var(--fs-chat-dark-action)',
  '--button-primary-text-color': 'var(--fs-chat-dark-action-text)',
  '--button-success-color': 'var(--fs-chat-dark-success)',
  '--button-danger-color': 'var(--fs-chat-dark-error)',
  '--button-danger-text-color': '#fff',
  '--snackbar-success-background':
    'color-mix(in srgb, var(--fs-chat-dark-success) 52%, transparent)',
  '--snackbar-info-background': 'color-mix(in srgb, var(--fs-chat-dark-info) 52%, transparent)',
  '--snackbar-warning-background':
    'color-mix(in srgb, var(--fs-chat-dark-warning) 52%, transparent)',
  '--snackbar-error-background': 'color-mix(in srgb, var(--fs-chat-dark-error) 58%, transparent)',
} as const;

export { darkTheme, lightTheme };
